import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { DeleteDialogService } from 'services/delete-dialog-service';
import { ErrorService } from 'services/error-service';
import { RecyclingCompanyService } from 'services/recycling-company-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class RecyclingCompanyDetail {
  private recyclingCompany: Models.RecyclingCompany;

  constructor(
    private recyclingCompanyService: RecyclingCompanyService,
    private errorService: ErrorService,
    private router: Router,
    private toastService: ToastService,
    private eventAggregator: EventAggregator,
    private deleteDialogService: DeleteDialogService
  ) {}

  private activate(params) {
    this.recyclingCompanyService
      .get(params.Id)
      .then((res) => {
        this.recyclingCompany = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private updateRecyclingCompany() {
    this.recyclingCompanyService
      .put(this.recyclingCompany, this.recyclingCompany.Id)
      .then((res) => {
        this.eventAggregator.publish('recyclingCompanyListReset', 1);
        this.toastService.showSuccess('RecyclingCompany.updated');
        this.router.navigateToRoute('recycling-company-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private deleteRecyclingCompany() {
    this.deleteDialogService.confirmBeforeDelete(
      () => {
        this.recyclingCompanyService
          .delete(this.recyclingCompany.Id)
          .then((res) => {
            this.eventAggregator.publish('recyclingCompanyListReset', 1);
            this.toastService.showSuccess('recyclingCompany.deleted');
            this.router.navigateToRoute('recycling-company-list');
          })
          .catch((err) => this.errorService.handleError(err));
        }
      );
  }

  private gotoParentView() {
    this.eventAggregator.publish('recyclingCompanyListReset', 1);
    this.router.navigateToRoute('recycling-company-list');
  }
}
